module.exports = __webpack_public_path__ + "static/img/code1.64beb8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code1.png
// module id = D5eY
// module chunks = 11